import { THEME } from '@lyon/utils/theme';
import { StyleObject } from 'styletron-react';

const INDETERMINATE: StyleObject = {
  marginRight: '16px',
  position: 'relative',
  bottom: '2px',
  color: THEME.colors.mono600,
};

const CHECK: StyleObject = {
  ...INDETERMINATE,
  color: THEME.colors.positive400,
};

const WRONG: StyleObject = {
  ...INDETERMINATE,
  color: THEME.colors.negative400,
};

export const ICON = {
  correct: CHECK,
  incorrect: WRONG,
  indeterminate: INDETERMINATE,
};
